import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const LeadSearchRecord = Record({
  amount: 0,
  id: 0,
  period: 0,
});

export default class LeadSearch extends LeadSearchRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new LeadSearch(hydrated);
  }
}
